/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { rfqConfirmationDetailsStyles } from "@monsma/Overrides/Widgets/RfqConfirmation/RfqConfirmationDetails";
import { css } from "styled-components";

rfqConfirmationDetailsStyles.detailsGridContainer = {
    gap: 30,
    css: css`
        div[class^="GridOffset"] {
            width: calc(100% + 30px);
        }
    `,
};

rfqConfirmationDetailsStyles.leftColumnInnerGridContainer = {
    gap: 15,
};

rfqConfirmationDetailsStyles.jobNameHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqConfirmationDetailsStyles.salesRepHeadingAndText = {
    heading: titleText,
    text: contentText,
};
rfqConfirmationDetailsStyles.statusHeadingAndText = {
    heading: titleText,
    text: contentText,
};
rfqConfirmationDetailsStyles.customerHeadingAndText = {
    heading: titleText,
    text: contentText,
};
rfqConfirmationDetailsStyles.shipToHeadingAndText = {
    heading: titleText,
    text: contentText,
};

rfqConfirmationDetailsStyles.statusGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

rfqConfirmationDetailsStyles.jobNameGridItem = rfqConfirmationDetailsStyles.statusGridItem;

rfqConfirmationDetailsStyles.salesRepGridItem = rfqConfirmationDetailsStyles.statusGridItem;

rfqConfirmationDetailsStyles.dateGridItem = rfqConfirmationDetailsStyles.statusGridItem;

rfqConfirmationDetailsStyles.customerGridItem = rfqConfirmationDetailsStyles.statusGridItem;

rfqConfirmationDetailsStyles.shipToGridItem = rfqConfirmationDetailsStyles.statusGridItem;

rfqConfirmationDetailsStyles.rightColumnGridItem = { width: 12 };

rfqConfirmationDetailsStyles.leftColumnGridItem = { width: 12 };

rfqConfirmationDetailsStyles.dateLabelText = titleText;
rfqConfirmationDetailsStyles.xRfqConfirmationDetailsStyles = { dateText: contentText };
